var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 379.88 265.89",
    style: {
      enableBackground: "new 0 0 379.88 265.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.33,30.66H45.55c-6.09,0-11.03,4.94-11.03,11.03v182.53c0,6.09,4.94,11.03,11.03,11.03h288.78 c6.09,0,11.03-4.94,11.03-11.03V41.68C345.36,35.59,340.42,30.66,334.33,30.66z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -105.5847,
    y1: 843.1266,
    x2: -105.4957,
    y2: 842.1065,
    gradientTransform: "matrix(256 0 0 82.6684 27208.291 -69524.0391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252756"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B4D9C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.34,118.04c-0.15,11.52,10.26,17.94,18.1,21.76c8.06,3.92,10.76,6.43,10.73,9.94 c-0.06,5.37-6.43,7.73-12.38,7.83c-10.39,0.16-16.44-2.81-21.24-5.05l-3.74,17.52c4.82,2.22,13.74,4.16,23,4.24 c21.72,0,35.94-10.72,36.01-27.35c0.08-21.1-29.19-22.27-28.99-31.7c0.07-2.86,2.8-5.91,8.78-6.69 c2.96-0.39,11.13-0.69,20.39,3.57l3.64-16.95c-4.98-1.81-11.38-3.55-19.36-3.55C208.83,91.61,194.45,102.48,194.34,118.04  M283.58,93.07c-3.97,0-7.31,2.31-8.8,5.87l-31.03,74.1h21.71l4.32-11.94h26.53l2.51,11.94h19.13l-16.7-79.96H283.58  M286.61,114.67l6.27,30.03h-17.16L286.61,114.67 M168.01,93.07l-17.11,79.96h20.69l17.1-79.96H168.01 M137.41,93.07l-21.53,54.43 l-8.71-46.28c-1.02-5.17-5.06-8.15-9.54-8.15h-35.2l-0.49,2.32c7.23,1.57,15.44,4.1,20.41,6.8c3.04,1.65,3.91,3.1,4.91,7.03 l16.5,63.81h21.86l33.52-79.96H137.41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.5fe097b9e8acbcaf42ef546cf0568060.svg";
export { ForwardRef as ReactComponent };